import * as React from 'react';
import { History } from 'history';
import Model from './transactionamount-model';
import BaseList from '../base/base-list.component';

interface IProps { 
  history: History;
  root?: string;
  transactionId: number;
  actions?: any;
  disableBackButton?: boolean;
  disableCard?: boolean;
  onLoad?: (data: any) => void;
  onLoadAll?: (data: any) => void;
}

interface IState {
}

export default class TransactionamountList extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
  }

  private onLoadAll = (data: any) => {
    const total = data?.reduce((v: number, d: any) => { return v + d.value}, 0);
    this.props.onLoadAll?.({'data': data, 'total': total});
  }

  public render(): React.ReactNode {
    return (
      <BaseList history={this.props.history} parentId={this.props.transactionId} endPointFilter={Model.endPointFilter+this.props.transactionId} url={(this.props.root || '') + Model.url} model={Model} onLoad={this.props.onLoad} onLoadAll={this.onLoadAll} actions={this.props.actions} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
